import React from "react";

const BookItem = (props) => {
  const imageSrc= props.bookDetails.book_cover;

  return (
    <React.Fragment>
      <div className="book-info">
        <div>
          <img
            style={{ width: "100px", height: "125px" }}
            src={
              imageSrc
                ? `data:image/jpeg;base64,${imageSrc}`
                : "ElsevierStyleSheet/images/ElsevierImage.png"
            }
            alt=""
          />
        </div>
        <div className="font-16">{props.bookDetails.title}</div>
        <div className="font-14 margin-5">
          <strong>Published: </strong> {props.bookDetails.year}
        </div>
        <div className="font-14 margin-5">
          <strong>Subject: </strong>
          {props.bookDetails.subject}
        </div>
        <div className="font-14 margin-5">
          <strong>ISBN: </strong>
          {props.bookDetails.product_id}
        </div>
      </div>
    </React.Fragment>
  );
};

export default BookItem;